//
// KeyCode.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var KeyCode = {
    PVK_A:0,
    PVK_B:1,
    PVK_C:2,
    PVK_D:3,
    PVK_E:4,
    PVK_F:5,
    PVK_G:6,
    PVK_H:7,
    PVK_I:8,
    PVK_J:9,
    PVK_K:10,
    PVK_L:11,
    PVK_M:12,
    PVK_N:13,
    PVK_O:14,
    PVK_P:15,
    PVK_Q:16,
    PVK_R:17,
    PVK_S:18,
    PVK_T:19,
    PVK_U:20,
    PVK_V:21,
    PVK_W:22,
    PVK_X:23,
    PVK_Y:24,
    PVK_Z:25,
    PVK_0:26,
    PVK_1:27,
    PVK_2:28,
    PVK_3:29,
    PVK_4:30,
    PVK_5:31,
    PVK_6:32,
    PVK_7:33,
    PVK_8:34,
    PVK_9:35,
    PVK_MINUS:36,
    PVK_EQUALS:37,
    PVK_COMMA:38,
    PVK_PERIOD:39,
    PVK_SEMICOLON:40,
    PVK_APOSTROPHE:41,
    PVK_LEFTBRACKET:42,
    PVK_RIGHTBRACKET:43,
    PVK_FORWARDSLASH:44,
    PVK_BACKSLASH:45,
    PVK_SPACE:46,
    PVK_ENTER:47,
    PVK_TAB:48,
    PVK_PAGEUP:49,
    PVK_PAGEDOWN:50,
    PVK_LEFTARROW:51,
    PVK_RIGHTARROW:52,
    PVK_DOWNARROW:53,
    PVK_UPARROW:54,
    PVK_CONTROL:55,
    PVK_ALT:56,
    PVK_SUPER:57,
    PVK_SHIFT:58,
    PVK_HOME:59,
    PVK_END:60,
    PVK_ESCAPE:61,
    PVK_F1:62,
    PVK_F2:63,
    PVK_F3:64,
    PVK_F4:65,
    PVK_F5:66,
    PVK_F6:67,
    PVK_F7:68,
    PVK_F8:69,
    PVK_F9:70,
    PVK_F10:71,
    PVK_F11:72,
    PVK_F12:73,
    PVK_ANY:74
};
export default KeyCode;
